module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('div', {
    attrs: {
      "id": "loading-div"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "container"
  }, [_c('button', {
    staticClass: "btn btn-orange btn-block w-auto px-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.viewBack
    }
  }, [_vm._v("\n        Wróć\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("Informacje o pracowniku")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Imię i nazwisko")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.details.name) + " " + _vm._s(this.details.surname))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.details.login) + "@lekseek.com")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Opiekun")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(this.details.supervisor))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Dział")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.areaFilter))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Projekt")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getProject()))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Godziny "), _c('br'), _vm._v("(obecny miesiąc)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getCurrentMonthWorktime()))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Godziny "), _c('br'), _vm._v("(poprzedni miesiąc)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getPreviousMonthWorktime()))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Średnia godzin "), _c('br'), _vm._v("(3 miesiące)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getThreeMonthAverageWorktime()))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col1"
  }, [_vm._v("Średnia godzin "), _c('br'), _vm._v("(dzienna)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDailyAverageWorktime()))])])])]), _vm._v(" "), (_vm.showGitSection) ? _c('div', {
    staticClass: "col-lg"
  }, [_c('EmployeeGitStatus', {
    attrs: {
      "gitlabSummary": _vm.gitlabSummary
    }
  })], 1) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-93396ace!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/ia/EmployeeDetails.vue
// module id = 1106
// module chunks = 0